// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://szbvvvxyamindcuymrcr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6YnZ2dnh5YW1pbmRjdXltcmNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzODE3MDIsImV4cCI6MjA2Mzk1NzcwMn0.1WGZepdzawUSM0i0Mw2ikY42pdmKzfqgunMeMoMs4-M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);